import { ReportPage, ReportTable } from '@/components';
import type { InvestmentFundTableProps } from '@/features/mold/utils/pdf/pdf-components-props';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const InvestmentFundReportFormat: FC<InvestmentFundTableProps> = ({
  fiscalYear,
  header,
  rowData,
  paperSize,
  dateByCreated,
}) => {
  const { t } = useTranslation();

  return (
    <ReportPage
      title={{
        text: t('report-investment-fund-title', {
          year: fiscalYear,
        }),
      }}
      layout={{
        paperSize,
        orientation: 'landscape',
      }}
      pagePadding={10}
      caption={{
        unit: 'thousand',
      }}
      dateByCreated={dateByCreated}
    >
      <ReportTable
        header={header}
        data={rowData}
        tableWidth="100%"
        borderColor="secondary"
      />
    </ReportPage>
  );
};
